module.exports = __webpack_public_path__ + "media/images/talent/point-03-5af81263099aee63d9f5d26497f48505.png";